(function () {
  // The product tabs (.pxu-tabs) are pure CSS: a radio input per tab, its
  // panel only occupies space once checked. Switching tabs can change the
  // page's total height a lot (e.g. a long Description collapsing while a
  // short Ingredients panel opens), but the browser's scroll offset never
  // adjusts for that — so the viewport can end up anywhere in the now much
  // shorter page, often well past the tabs into whatever follows (reviews).
  // Re-anchor scroll to the clicked tab whenever the layout shifts under it.
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.tab-radio')) {
      return;
    }
    var label = event.target.nextElementSibling;
    if (label && label.classList.contains('tab-label')) {
      label.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
